// // import React, { useEffect } from 'react';
// // import { Form, Input, Button, message, notification, Select,Space,InputNumber } from 'antd';
// // import { MinusCircleFilled,PlusOutlined,MinusCircleOutlined } from '@ant-design/icons';
// // import { useCreateUserAdminPMutation, useUpdateUserAdminPMutation } from '../../../slices/adminApiSlice';
// // import { useCreateSubAdminPMutation, useUpdateSubAdminPMutation } from '../../../slices/subscriptionApiSlice';

// // const SubForm = ({ sub, getSubs, onClose }) => {
// //   const [form] = Form.useForm();
// //   const [api, contextHolder] = notification.useNotification();

// //   const [createSub, { isLoading: isNewLoading }] = useCreateSubAdminPMutation();
// //   const [updateSub, { isLoading: isUpdateLoading }] = useUpdateSubAdminPMutation();


// //   useEffect(() => {
// //     form.resetFields();
// //     if (sub) {
// //       form.setFieldsValue(sub);
// //     }
// //   }, [sub, form]);

// //   const createsub = async (newSub) => {
// //     try {
// //       const res = await createSub(newSub).unwrap();
// //       message.success('Package added successfully');
// //       getSubs();
// //     } catch (err) {
// //       api.error({
// //         message: err?.data?.message || err.error || err?.data?.error || err?.data?.error
// //       });
// //     }
// //   }

// //   const updatesub = async (updatedSub) => {
// //     try {
// //       const res = await updateSub(updatedSub).unwrap();
// //       message.success('Package updated successfully');
// //       getSubs();
// //     } catch (err) {
// //       // console.log(err);
// //       api.error({
// //         message: err?.data?.message || err.error || err?.data?.error || err?.data?.error
// //       });
// //     }
// //   }

// //   // const addUserMutation = useMutation(async (newSub) => {
// //   //   await axios.post('/api/users', newSub);
// //   //   message.success('User added successfully');
// //   //   refetch();
// //   //   onClose();
// //   // });

// //   // const updateUserMutation = useMutation(async (updatedSub) => {
// //   //   await axios.put(`/api/users/${sub._id}`, updatedSub);
// //   //   message.success('User updated successfully');
// //   //   refetch();
// //   //   onClose();
// //   // });

// //   const handleSubmit = (values) => {
// //     if (sub) {
// //       updatesub(values);
// //     } else {
// //       createsub(values);
// //     }
// //   };

// //   return (
// //     <>
// //     {contextHolder}
// //     <Form form={form} layout="vertical" onFinish={handleSubmit}>
// //       <Form.Item name="id" hidden>
// //         <Input />
// //       </Form.Item>
// //       <Form.Item name="name" label="Name" rules={[{ required: true }]}>
// //         <Input />
// //       </Form.Item>
// //       {/* <Form.Item name="price" label="Price" rules={[{ required: true}]}>
// //         <Input type='number'/>
// //       </Form.Item>
// //       <Form.Item name="months" label="Months" rules={[{ required: true}]}>
// //         <Input type='number'/>
// //       </Form.Item>
// //       <Form.Item name="extradays" label="Extra Days" rules={[{ required: true}]}>
// //         <Input type='number'/>
// //       </Form.Item> */}
// //       <Form.Item name="price" label="Price" rules={[{ required: true }]}>
// //   <InputNumber style={{ width: '100%' }} />
// // </Form.Item>

// // <Form.Item name="months" label="Months" rules={[{ required: true }]}>
// //   <InputNumber style={{ width: '100%' }} />
// // </Form.Item>

// // <Form.Item name="extradays" label="Extra Days" rules={[{ required: true }]}>
// //   <InputNumber style={{ width: '100%' }} />
// // </Form.Item>

// //        {/* ✅ Tagline */}
// //         <Form.Item name="tagline" label="Tagline">
// //           <Input placeholder="Enter package tagline" />
// //         </Form.Item>

// //         {/* ✅ Editable Highlights */}
// //         <Form.List name="highlights">
// //           {(fields, { add, remove }) => (
// //             <>
// //               <label>Highlights</label>
// //               {fields.map(({ key, name, ...restField }) => (
// //                 <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
// //                   <Form.Item
// //                     {...restField}
// //                     name={name}
// //                     rules={[{ required: true, message: 'Please enter a highlight' }]}
// //                   >
// //                     <Input placeholder="Enter highlight" />
// //                   </Form.Item>
// //                   <MinusCircleOutlined onClick={() => remove(name)} />
// //                 </Space>
// //               ))}
// //               <Form.Item>
// //                 <Button type="dashed" onClick={() => add('')} block icon={<PlusOutlined />}>
// //                   Add Highlight
// //                 </Button>
// //               </Form.Item>
// //             </>
// //           )}
// //         </Form.List>

// //       <Form.Item name="active" label="Active" rules={[{ required: true}]}>
// //         <Select 
// //           options={[
// //             {
// //               value: true,
// //               label: 'Active',
// //             },
// //             {
// //               value: false,
// //               label: 'Inactive',
// //             },
// //           ]}
// //         />
// //       </Form.Item>
// //       <Form.Item>
// //         <Button htmlType="submit" loading={sub ? isUpdateLoading : isNewLoading}   className="gold-btn"
// // >
// //           {sub ? 'Update' : 'Add'} Package
// //         </Button>
// //       </Form.Item>
// //     </Form>
// //     </>
// //   );
// // };

// // export default SubForm;


// import React, { useEffect } from 'react';
// import { Form, Input, Button, message, notification, Select,Space,InputNumber,Switch } from 'antd';
// import { MinusCircleFilled,PlusOutlined,MinusCircleOutlined } from '@ant-design/icons';
// import { useCreateUserAdminPMutation, useUpdateUserAdminPMutation } from '../../../slices/adminApiSlice';
// import { useCreateSubAdminPMutation, useUpdateSubAdminPMutation } from '../../../slices/subscriptionApiSlice';

// const SubForm = ({ sub, getSubs, onClose }) => {
//   const [form] = Form.useForm();
//   const [api, contextHolder] = notification.useNotification();

//   const [createSub, { isLoading: isNewLoading }] = useCreateSubAdminPMutation();
//   const [updateSub, { isLoading: isUpdateLoading }] = useUpdateSubAdminPMutation();


//   useEffect(() => {
//     form.resetFields();
//     if (sub) {
//       form.setFieldsValue(sub);
//     }
//   }, [sub, form]);

//   const createsub = async (newSub) => {
//     try {
//       const res = await createSub(newSub).unwrap();
//       message.success('Package added successfully');
//       getSubs();
//     } catch (err) {
//       api.error({
//         message: err?.data?.message || err.error || err?.data?.error || err?.data?.error
//       });
//     }
//   }

//   const updatesub = async (updatedSub) => {
//     try {
//       const res = await updateSub(updatedSub).unwrap();
//       message.success('Package updated successfully');
//       getSubs();
//     } catch (err) {
//       // console.log(err);
//       api.error({
//         message: err?.data?.message || err.error || err?.data?.error || err?.data?.error
//       });
//     }
//   }

//   // const addUserMutation = useMutation(async (newSub) => {
//   //   await axios.post('/api/users', newSub);
//   //   message.success('User added successfully');
//   //   refetch();
//   //   onClose();
//   // });

//   // const updateUserMutation = useMutation(async (updatedSub) => {
//   //   await axios.put(`/api/users/${sub._id}`, updatedSub);
//   //   message.success('User updated successfully');
//   //   refetch();
//   //   onClose();
//   // });

//   const handleSubmit = (values) => {
//     if (sub) {
//       updatesub(values);
//     } else {
//       createsub(values);
//     }
//   };

//   return (
//     <>
//     {contextHolder}
//     <Form form={form} layout="vertical" onFinish={handleSubmit}>
//       <Form.Item name="id" hidden>
//         <Input />
//       </Form.Item>
//       <Form.Item name="name" label="Name" rules={[{ required: true }]}>
//         <Input />
//       </Form.Item>
//       {/* <Form.Item name="price" label="Price" rules={[{ required: true}]}>
//         <Input type='number'/>
//       </Form.Item>
//       <Form.Item name="months" label="Months" rules={[{ required: true}]}>
//         <Input type='number'/>
//       </Form.Item>
//       <Form.Item name="extradays" label="Extra Days" rules={[{ required: true}]}>
//         <Input type='number'/>
//       </Form.Item> */}
//       <Form.Item name="price" label="Price" rules={[{ required: true }]}>
//   <InputNumber style={{ width: '100%' }} />
// </Form.Item>

// <Form.Item name="months" label="Months" rules={[{ required: true }]}>
//   <InputNumber style={{ width: '100%' }} />
// </Form.Item>

// <Form.Item name="extradays" label="Extra Days" rules={[{ required: true }]}>
//   <InputNumber style={{ width: '100%' }} />
// </Form.Item>

//        {/* ✅ Tagline */}
//         <Form.Item name="tagline" label="Tagline">
//           <Input placeholder="Enter package tagline" />
//         </Form.Item>

//         {/* ✅ Editable Highlights */}
//         <Form.List name="highlights">
//           {(fields, { add, remove }) => (
//             <>
//               <label>Highlights</label>
//               {fields.map(({ key, name, ...restField }) => (
//                 <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
//                   <Form.Item
//                     {...restField}
//                     name={name}
//                     rules={[{ required: true, message: 'Please enter a highlight' }]}
//                   >
//                     <Input placeholder="Enter highlight" />
//                   </Form.Item>
//                   <MinusCircleOutlined onClick={() => remove(name)} />
//                 </Space>
//               ))}
//               <Form.Item>
//                 <Button type="dashed" onClick={() => add('')} block icon={<PlusOutlined />}>
//                   Add Highlight
//                 </Button>
//               </Form.Item>
//             </>
//           )}
//         </Form.List>

//         {/* ✅ Autopay */}
//        <Form.Item name="autopay" label="Billing Mode" valuePropName="checked" initialValue={false}>
//             <Switch checkedChildren="Autopay" unCheckedChildren="One-time" />
//       </Form.Item>

//       <Form.Item name="active" label="Active" rules={[{ required: true}]}>
//         <Select 
//           options={[
//             {
//               value: true,
//               label: 'Active',
//             },
//             {
//               value: false,
//               label: 'Inactive',
//             },
//           ]}
//         />
//       </Form.Item>
//       <Form.Item>
//         <Button htmlType="submit" loading={sub ? isUpdateLoading : isNewLoading}   className="gold-btn"
// >
//           {sub ? 'Update' : 'Add'} Package
//         </Button>
//       </Form.Item>
//     </Form>
//     </>
//   );
// };

// export default SubForm;


import React, { useEffect } from 'react';
import {
  Form,
  Input,
  Button,
  message,
  notification,
  Select,
  Space,
  InputNumber,
  Switch,
  Divider,
  Alert,
} from 'antd';

import {
  PlusOutlined,
  MinusCircleOutlined,
} from '@ant-design/icons';

import {
  useCreateSubAdminPMutation,
  useUpdateSubAdminPMutation,
} from '../../../slices/subscriptionApiSlice';

const SubForm = ({ sub, getSubs, onClose }) => {
  const [form] = Form.useForm();
  const [api, contextHolder] = notification.useNotification();

  const [createSub, { isLoading: isNewLoading }] =
    useCreateSubAdminPMutation();

  const [updateSub, { isLoading: isUpdateLoading }] =
    useUpdateSubAdminPMutation();

  useEffect(() => {
    form.resetFields();

    if (sub) {
      form.setFieldsValue({
        ...sub,
        autopay:
          sub.autopay === true ||
          sub.paymentMode?.toUpperCase() === 'AUTOPAY',
        billingInterval: sub.billingInterval || 'monthly',
        billingIntervalCount: sub.billingIntervalCount || 1,
        totalCount: sub.totalCount || 12,
        customerNotify: sub.customerNotify ?? true,
        trialDays: sub.trialDays || 0,
        razorpayPlanId: sub.razorpayPlanId || '',
      });
    } else {
      form.setFieldsValue({
        autopay: false,
        billingInterval: 'monthly',
        billingIntervalCount: 1,
        totalCount: 12,
        customerNotify: true,
        trialDays: 0,
        razorpayPlanId: '',
      });
    }
  }, [sub, form]);

  const createsub = async (newSub) => {
    try {
      await createSub(newSub).unwrap();

      message.success('Package added successfully');
      getSubs();
      onClose?.();
    } catch (err) {
      api.error({
        message:
          err?.data?.message ||
          err?.data?.error ||
          err?.error ||
          'Failed to create package',
      });
    }
  };

  const updatesub = async (updatedSub) => {
    try {
      await updateSub(updatedSub).unwrap();

      message.success('Package updated successfully');
      getSubs();
      onClose?.();
    } catch (err) {
      api.error({
        message:
          err?.data?.message ||
          err?.data?.error ||
          err?.error ||
          'Failed to update package',
      });
    }
  };

  const handleSubmit = (values) => {
    const payload = {
      ...values,

      // Keep the existing frontend flag.
      autopay: values.autopay === true,

      // Backend can use this field to select the payment flow.
      paymentMode: values.autopay ? 'AUTOPAY' : 'ONE_TIME',
    };

    if (values.autopay) {
      payload.billingInterval =
        values.billingInterval || 'monthly';

      payload.billingIntervalCount =
        values.billingIntervalCount || 1;

      payload.totalCount = values.totalCount || 12;

      payload.customerNotify =
        values.customerNotify === true;

      payload.trialDays = values.trialDays || 0;

      // Blank means the backend should create the Razorpay plan.
      payload.razorpayPlanId =
        values.razorpayPlanId?.trim() || '';
    } else {
      // Do not send stale AutoPay configuration for one-time plans.
      payload.billingInterval = '';
      payload.billingIntervalCount = 0;
      payload.totalCount = 0;
      payload.customerNotify = false;
      payload.trialDays = 0;
      payload.razorpayPlanId = '';
    }

    if (sub) {
      updatesub(payload);
    } else {
      createsub(payload);
    }
  };

  return (
    <>
      {contextHolder}

      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
      >
        <Form.Item name="id" hidden>
          <Input />
        </Form.Item>

        <Form.Item
          name="name"
          label="Package Name"
          rules={[
            { required: true, message: 'Enter package name' },
          ]}
        >
          <Input placeholder="Enter package name" />
        </Form.Item>

        <Form.Item
          name="price"
          label="Price"
          rules={[
            { required: true, message: 'Enter package price' },
          ]}
        >
          <InputNumber
            min={0.01}
            precision={2}
            style={{ width: '100%' }}
            placeholder="Enter price"
          />
        </Form.Item>

        <Form.Item
          name="months"
          label="Validity (Months)"
          rules={[
            { required: true, message: 'Enter validity in months' },
          ]}
        >
          <InputNumber
            min={0}
            precision={0}
            style={{ width: '100%' }}
          />
        </Form.Item>

        <Form.Item
          name="extradays"
          label="Extra Days"
          rules={[
            { required: true, message: 'Enter extra days' },
          ]}
        >
          <InputNumber
            min={0}
            precision={0}
            style={{ width: '100%' }}
          />
        </Form.Item>

        <Form.Item name="tagline" label="Tagline">
          <Input placeholder="Enter package tagline" />
        </Form.Item>

        <Form.List name="highlights">
          {(fields, { add, remove }) => (
            <>
              <label>Highlights</label>

              {fields.map(({ key, name, ...restField }) => (
                <Space
                  key={key}
                  style={{
                    display: 'flex',
                    marginBottom: 8,
                  }}
                  align="baseline"
                >
                  <Form.Item
                    {...restField}
                    name={name}
                    rules={[
                      {
                        required: true,
                        message: 'Please enter a highlight',
                      },
                    ]}
                  >
                    <Input placeholder="Enter highlight" />
                  </Form.Item>

                  <MinusCircleOutlined
                    onClick={() => remove(name)}
                  />
                </Space>
              ))}

              <Form.Item>
                <Button
                  type="dashed"
                  onClick={() => add('')}
                  block
                  icon={<PlusOutlined />}
                >
                  Add Highlight
                </Button>
              </Form.Item>
            </>
          )}
        </Form.List>

        <Divider />

        <Form.Item
          name="autopay"
          label="Billing Mode"
          valuePropName="checked"
          initialValue={false}
        >
          <Switch
            checkedChildren="AutoPay"
            unCheckedChildren="One-time"
          />
        </Form.Item>

        <Form.Item
          noStyle
          shouldUpdate={(prev, curr) =>
            prev.autopay !== curr.autopay
          }
        >
          {({ getFieldValue }) =>
            getFieldValue('autopay') ? (
              <>
                <Divider orientation="left">
                  AutoPay Configuration
                </Divider>

                <Alert
                  type="info"
                  showIcon
                  style={{ marginBottom: 16 }}
                  message="Recurring billing configuration"
                  description="The backend must create or validate the Razorpay Plan before creating a customer subscription."
                />

                <Form.Item
                  name="billingInterval"
                  label="Billing Interval"
                  rules={[
                    {
                      required: true,
                      message: 'Select billing interval',
                    },
                  ]}
                >
                  <Select
                    options={[
                      { value: 'daily', label: 'Daily' },
                      { value: 'weekly', label: 'Weekly' },
                      { value: 'monthly', label: 'Monthly' },
                      { value: 'yearly', label: 'Yearly' },
                    ]}
                  />
                </Form.Item>

                <Form.Item
                  name="billingIntervalCount"
                  label="Repeat Every"
                  rules={[
                    {
                      required: true,
                      message: 'Enter billing interval count',
                    },
                  ]}
                >
                  <InputNumber
                    min={1}
                    precision={0}
                    style={{ width: '100%' }}
                    addonAfter="interval(s)"
                  />
                </Form.Item>

                <Form.Item
                  name="totalCount"
                  label="Total Billing Cycles"
                  tooltip="Number of recurring billing cycles configured for the Razorpay subscription."
                  rules={[
                    {
                      required: true,
                      message: 'Enter total billing cycles',
                    },
                  ]}
                >
                  <InputNumber
                    min={1}
                    precision={0}
                    style={{ width: '100%' }}
                    placeholder="e.g. 12"
                  />
                </Form.Item>

                <Form.Item
                  name="razorpayPlanId"
                  label="Razorpay Plan ID (Optional)"
                  tooltip="Leave blank only if your backend automatically creates the Razorpay Plan."
                >
                  <Input
                    placeholder="plan_XXXXXXXXXXXX"
                  />
                </Form.Item>

                <Form.Item
                  name="customerNotify"
                  label="Razorpay Customer Notifications"
                  valuePropName="checked"
                >
                  <Switch
                    checkedChildren="Enabled"
                    unCheckedChildren="Disabled"
                  />
                </Form.Item>

                <Form.Item
                  name="trialDays"
                  label="Trial Period (Days)"
                  tooltip="Optional. The backend must implement trial handling if required."
                >
                  <InputNumber
                    min={0}
                    precision={0}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </>
            ) : null
          }
        </Form.Item>

        <Form.Item
          name="active"
          label="Status"
          rules={[
            { required: true, message: 'Select package status' },
          ]}
        >
          <Select
            options={[
              { value: true, label: 'Active' },
              { value: false, label: 'Inactive' },
            ]}
          />
        </Form.Item>

        <Form.Item>
          <Button
            htmlType="submit"
            loading={sub ? isUpdateLoading : isNewLoading}
            className="gold-btn"
          >
            {sub ? 'Update' : 'Add'} Package
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default SubForm; 